/**
 * Controller that coordinates flush across observability subsystems.
 * Hosts (React Native, browser lifecycle, etc.) call `flush()` to
 * trigger immediate delivery of buffered data.
 */
export default class FlushController {
  public readonly signal: FlushSignal;

  constructor() {
    this.signal = new FlushSignal();
  }

  /**
   * Dispatches the flush event, causing all observability subsystems
   * listening on this signal to flush buffered data.
   */
  flush(): void {
    this.signal.dispatch();
  }
}

type Listener = () => void;

export class FlushSignal {
  private listeners: Set<Listener> = new Set();

  addEventListener(listener: Listener): void {
    this.listeners.add(listener);
  }

  removeEventListener(listener: Listener): void {
    this.listeners.delete(listener);
  }

  /** @internal – only FlushController should call this */
  dispatch(): void {
    for (const listener of this.listeners) {
      listener();
    }
  }
}
